export const AG_GRID_LOCALE_TR = {
    // Set Filter
    selectAll: '(Hepsini seç)',
    selectAllSearchResults: '(Tüm Arama Sonuçlarını Seç)',
    searchOoo: 'Arama...',
    blanks: '(Boşluklar)',
    noMatches: 'Eşleşme yok',

    // Number Filter & Text Filter
    filterOoo: 'Filtrele ...',
    equals: 'Eşittir',
    notEqual: 'Eşit Değildir',
    empty: 'Seçiniz',

    // Number Filter
    lessThan: 'Küçüktür',
    greaterThan: 'Büyüktür',
    lessThanOrEqual: 'Küçük Eşit',
    greaterThanOrEqual: 'Büyük Eşit',
    inRange: 'Aralık İçinde',
    inRangeStart: 'Başlangıç',
    inRangeEnd: 'Bitiş',

    // Text Filter
    contains: 'İçerir',
    notContains: 'İçermez',
    startsWith: 'İle Başlar',
    endsWith: 'İle Biter',

    // Date Filter
    dateFormatOoo: 'gg-aa-yyyy',

    // Filter Conditions
    andCondition: 'VE',
    orCondition: 'VEYA',

    // Filter Buttons
    applyFilter: 'Uygula',
    resetFilter: 'Sıfırla',
    clearFilter: 'Temizle',
    cancelFilter: 'İptal Et',

    // Filter Titles
    textFilter: 'Metin Filtresi',
    numberFilter: 'Rakam Filtresi',
    dateFilter: 'Tarih Filtresi',
    setFilter: 'Filtre Ayarla',

    // Side Bar
    columns: 'Sütunlar',
    filters: 'Filtreler',
    actionsBar: 'İşlemler',

    // columns tool panel
    pivotMode: 'Pivot Modu',
    groups: 'Satır Grupları',
    rowGroupColumnsEmptyMessage: 'Satır gruplarını ayarlamak için buraya sürükleyin',
    values: 'Değerler',
    valueColumnsEmptyMessage: 'Birleştirmek için buraya sürükleyin',
    pivots: 'Sütun Etiketleri',
    pivotColumnsEmptyMessage: 'Sütun etiketlerini ayarlamak için buraya sürükleyin',

    // Header of the Default Group Column
    group: 'Grup',

    // Other
    loadingOoo: 'Yükleniyor...',
    noRowsToShow: 'Gösterilecek Veri Yok',
    enabled: 'Etkin',

    // Menu
    pinColumn: 'Pin Sütunu',
    pinLeft: 'Sola Sabitle',
    pinRight: 'Sağa Sabitle',
    noPin: 'Pin Yok',
    valueAggregation: 'Değer Birleştirme',
    autosizeThiscolumn: 'Bu Sütunu Otomatik Boyutlandır',
    autosizeAllColumns: 'Tüm Sütunları Otomatik Boyutlandır',
    groupBy: 'Grupla',
    ungroupBy: 'Gruplama',
    resetColumns: 'Sütunları Sıfırla',
    expandAll: 'Hepsini genişlet',
    collapseAll: 'Hepsini kapat',
    copy: 'Kopyala',
    ctrlC: 'Ctrl + C',
    copyWithHeaders: 'Başlıklar ile Kopyala',
    paste: 'Yapıştırmak',
    ctrlV: 'Ctrl + V',
    export: 'Dışa Aktar',
    csvExport: 'CSV Dışa Aktar (.csv)',
    excelExport: 'Excel Dışa Aktar (.xlsx)',
    excelXmlExport: 'XML Dışa Aktar (.xml)',

    // Enterprise Menu Aggregation and Status Bar
    sum: 'Toplam',
    min: 'Min',
    max: 'Maks',
    none: 'Yok',
    count: 'Satır',
    average: 'Ortalama',
    filteredRows: 'Filtrelenmiş',
    selectedRows: 'Seçildi',
    totalRows: 'Toplam Satır',
    totalAndFilteredRows: 'Kayıt Sayısı',
    more: 'Daha',
    to: '',
    of: '',
    page: 'Sayfa',
    nextPage: 'Sonraki Sayfa',
    lastPage: 'Son Sayfa',
    firstPage: 'İlk sayfa',
    previousPage: 'Önceki sayfa',

    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: 'Pivot Chart & Pivot Modu',
    pivotChart: 'Özet Şeması',
    chartRange: 'Grafik Aralığı',

    columnChart: 'Sütun',
    groupedColumn: 'Gruplanmış',
    stackedColumn: 'Yığılmış',
    normalizedColumn: '% 100 Yığılmış',

    barChart: 'Bar',
    groupedBar: 'Gruplanmış',
    stackedBar: 'Yığılmış',
    normalizedBar: '% 100 Yığılmış',

    pieChart: 'Turta',
    pie: 'Turta',
    doughnut: 'Tatlı çörek',

    line: 'Hat',

    xyChart: 'X Y (Dağılım)',
    scatter: 'Dağılım',
    bubble: 'Kabarcık',

    areaChart: 'Alan',
    area: 'Alan',
    stackedArea: 'Yığılmış',
    normalizedArea: '% 100 Yığılmış',

    histogramChart: 'Histogram',

    // Charts
    pivotChartTitle: 'Özet Şeması',
    rangeChartTitle: 'Menzil Tablosu',
    settings: 'Ayarlar',
    data: 'Veri',
    format: 'Biçim',
    categories: 'Kategoriler',
    defaultCategory: '(Yok)',
    series: 'Dizi',
    xyValues: 'X Y Değerleri',
    paired: 'Eşleştirilmiş Mod',
    axis: 'Eksen',
    navigator: 'Navigator',
    color: 'Renk',
    thickness: 'Kalınlık',
    xType: 'X Tipi',
    automatic: 'Otomatik',
    category: 'Kategori',
    number: 'Numara',
    time: 'Zaman',
    xRotation: 'X Dönüşü',
    yRotation: 'Y Dönüşü',
    ticks: 'Keneler',
    width: 'Genişlik',
    height: 'Yükseklik',
    length: 'Uzunluk',
    padding: 'Dolgu malzemesi',
    spacing: 'Aralık',
    chart: 'Grafik',
    title: 'Başlık',
    titlePlaceholder: 'Grafik başlığı - düzenlemek için çift tıklayın',
    background: 'Arka fon',
    font: 'Yazı tipi',
    top: 'Üst',
    right: 'Sağ',
    bottom: 'Alt',
    left: 'Ayrıldı',
    labels: 'Etiketler',
    size: 'Boyut',
    minSize: 'En küçük beden',
    maxSize: 'En büyük boy',
    legend: 'Efsane',
    position: 'Durum',
    markerSize: 'İşaret Boyutu',
    markerStroke: 'Marker Stroke',
    markerPadding: 'İşaretçi Dolgusu',
    itemSpacing: 'Öğe Aralığı',
    itemPaddingX: 'Öğe Dolgu X',
    itemPaddingY: 'Öğe Dolgu Y',
    layoutHorizontalSpacing: 'Yatay Aralık',
    layoutVerticalSpacing: 'Dikey Aralık',
    strokeWidth: 'Darbe genişliği',
    offset: 'Ofset',
    offsets: 'Ofsetler',
    tooltips: 'Araç ipuçları',
    callout: 'Çağır',
    markers: 'İşaretçiler',
    shadow: 'Gölge',
    blur: 'Bulanıklık',
    xOffset: 'X Ofset',
    yOffset: 'Y Ofseti',
    lineWidth: 'Hat genişliği',
    normal: 'Normal',
    bold: 'Kalın',
    italic: 'İtalik',
    boldItalic: 'Kalın italik',
    predefined: 'Önceden tanımlanmış',
    fillOpacity: 'Opaklığı Doldur',
    strokeOpacity: 'Çizgi Opaklığı',
    histogramBinCount: 'Bin sayısı',
    columnGroup: 'Sütun',
    barGroup: 'Bar',
    pieGroup: 'Turta',
    lineGroup: 'Hat',
    scatterGroup: 'X Y (Dağılım)',
    areaGroup: 'Alan',
    histogramGroup: 'Histogram',
    groupedColumnTooltip: 'Gruplanmış',
    stackedColumnTooltip: 'Yığılmış',
    normalizedColumnTooltip: '% 100 Yığılmış',
    groupedBarTooltip: 'Gruplanmış',
    stackedBarTooltip: 'Yığılmış',
    normalizedBarTooltip: '% 100 Yığılmış',
    pieTooltip: 'Turta',
    doughnutTooltip: 'Tatlı çörek',
    lineTooltip: 'Hat',
    groupedAreaTooltip: 'Alan',
    stackedAreaTooltip: 'Yığılmış',
    normalizedAreaTooltip: '% 100 Yığılmış',
    scatterTooltip: 'Dağılım',
    bubbleTooltip: 'Kabarcık',
    histogramTooltip: 'Histogram',
    noDataToChart: 'Grafiği gösterilecek veri yok.',
    pivotChartRequiresPivotMode: 'Pivot Chart, Pivot Modunun etkinleştirilmesini gerektirir.'
};
